import React, { useState } from "react";
import {
  AddressbookContactType,
  AddressbookNotificationBroker,
  IAddressbook,
} from "../../Interfaces/addressbook";
import TextInput from "../../Components/TextInput";
import Form from "../../Components/Form";
import StaticDropdown from "../../Components/Dropdown/StaticDropdown";
import { DropdownItem } from "../../Interfaces/dropdownInterfaces";
import Button from "../../Components/Button";
import { addAddressbook } from "../../Requests/addressbook";
import { toast } from "react-toastify";
import { packetErrorHandler } from "../../Utils/requestUtils";

interface IProps {
  refreshTable: () => void;
}

const AddForm = ({ refreshTable }: IProps) => {
  const [formValues, setFormValues] = useState({} as IAddressbook);
  const [loading, setLoading] = useState(false);

  const changeHandler = (name: string, value: any) => {
    setFormValues({ ...formValues, [name]: value });
  };

  const notificationBrokerTypeOption: DropdownItem[] = [
    { id: AddressbookNotificationBroker.Farabi, name: "فارابی" },
    {
      id: AddressbookNotificationBroker.Pasargard,
      name: "پاسارگاد",
    },
    { id: AddressbookNotificationBroker.Pishro, name: "پیشرو" },
    { id: AddressbookNotificationBroker.Sahra, name: "صحرا" },
  ];

  const contactTypeOption: DropdownItem[] = [
    { id: AddressbookContactType.Email, name: "ایمیل" },
    { id: AddressbookContactType.Phone, name: "تلفن همراه" },
    { id: AddressbookContactType.Telegram, name: "تلگرام" },
  ];

  const addHandler = () => {
    setLoading(true);
    addAddressbook(formValues)
      .then((resp) => {
        if (!resp.data) toast.error(resp.msg);
        else {
          toast.success(resp.msg);
          refreshTable();
        }
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <Form className="!w-80 gap-3 p-2 px-2">
      <TextInput
        label="عنوان"
        value={formValues.title}
        name="title"
        onChange={changeHandler}
        extraLabel
      />
      <TextInput
        label="آدرس"
        value={formValues.address}
        name="address"
        onChange={changeHandler}
        extraLabel
      />
      <StaticDropdown
        dropdown={{
          name: "notificationBrokerType",
          placeholder: "نوع notificationBroker",
          extraLabel: true,
        }}
        onChange={changeHandler}
        options={notificationBrokerTypeOption}
        value={formValues.notificationBrokerType}
      />
      <StaticDropdown
        dropdown={{
          name: "contactType",
          placeholder: "نوع ارتباط",
          extraLabel: true,
        }}
        onChange={changeHandler}
        options={contactTypeOption}
        value={formValues.contactType}
      />
      <Button
        text="ثبت"
        onClick={addHandler}
        variant="contained"
        loading={loading}
      />
    </Form>
  );
};

export default AddForm;
